import { getAPIUrl } from '../API'

//make post api call to /Deeds/TitleDeed
export type TitleDeedParams =
  | {
      cmaid: string
    }
  | {
      schemeNo: string
      sectionNo: string
    }

export const requestTitleDeed = async (values: TitleDeedParams) => {
  //make api call
  const response = await fetch(getAPIUrl() + `/Deeds/TitleDeed`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${sessionStorage.getItem('jwt')}`,
    },
    body: JSON.stringify(values),
  })

  if (!response.ok) {
    const data = await response.json()
    return data.data
  }
}

export type TitleDeedAccessResponse = {
  billType: string
  subscriberDOPerm: boolean
  agentDOPerm: boolean
}

export const getTitleDeedAccess = async () => {
  //make api call
  const response = await fetch(getAPIUrl() + `/User/debit-order-permission`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${sessionStorage.getItem('jwt')}`,
    },
  })

  if (response.ok) {
    const data = await response.json()
    return data.data as TitleDeedAccessResponse
  }
}
